import { Bus, Car, Clock, HelpCircle } from "lucide-react";

export const formatEur = (n) => `€${Number(n).toFixed(2)}`;

export const formatTime = (timestamp) => {
  const date = new Date(timestamp);
  return `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
};

export const formatDuration = (departure, arrival) => {
  const diffMs = arrival - departure;
  const totalMin = Math.round(diffMs / 60000);
  const h = Math.floor(totalMin / 60);
  const m = totalMin % 60;
  if (h === 0) return `${m} min`;
  if (m === 0) return `${h} h`;
  return `${h} h ${m} min`;
};

export const formatDistance = (meters) => {
  if (!meters) return null;
  if (meters < 1000) return `${meters} m`;
  return `${(meters / 1000).toFixed(1)} km`;
};

export const getTransportIcon = (transportType) => {
  switch (transportType) {
    case "bus-transport":
      return Bus;
    case "car":
      return Car;
    case "wait":
      return Clock;
    default:
      return HelpCircle;
  }
};
